import React, { useState, useEffect } from 'react';
import { string } from 'prop-types';
import { FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import { IconSpinner } from '../../components';

import css from './SectionHero.css';

const BACKGROUND_URL =
  'https://kindershare-public-files.s3-ap-southeast-2.amazonaws.com/videos/1017809383-hd+(1).mp4';

const SectionHero = props => {
  const { rootClassName, className, onBrowseListing, searching } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <div className={classes}>
      <video loop autoPlay muted playsInline preload="none" className={css.videoHero}>
        <source src={BACKGROUND_URL} type="video/mp4" />
      </video>

      <div className={css.heroContent}>
        <h1 className={css.heroMainTitle}>
          <FormattedMessage id="SectionHero.title" />
        </h1>
        <h2 className={css.heroSubTitle}>
          <FormattedMessage id="SectionHero.subTitle" />
        </h2>

        <div
          name="SearchPage"
          to={{
            search:
              'address=Finland&bounds=70.0922932%2C31.5870999%2C59.693623%2C20.456500199999937',
          }}
          onClick={onBrowseListing}
          className={css.heroButton}
        >
          {searching ? (
            <IconSpinner className={css.spiner} />
          ) : (
            <FormattedMessage id="SectionHero.browseButton" />
          )}
        </div>
      </div>
    </div>
  );
};

SectionHero.defaultProps = { rootClassName: null, className: null };

SectionHero.propTypes = {
  rootClassName: string,
  className: string,
};

export default SectionHero;
